import { render, staticRenderFns } from "./yes_no.vue?vue&type=template&id=f29ef316&scoped=true&"
import script from "./yes_no.vue?vue&type=script&lang=js&"
export * from "./yes_no.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29ef316",
  null
  
)

export default component.exports